import { Pipe, PipeTransform } from '@angular/core';
import {AnyObject, CardStructureConfig, CommonDataSetAction, ItemAttrListDataSet, ItemIconRender} from '@mri/types';

@Pipe({
  name: 'cardIconRender'
})
export class CardIconRenderPipe implements PipeTransform {

  transform( date: AnyObject, action: CommonDataSetAction, prop: ItemAttrListDataSet): string {
    if(typeof action.icon === 'function') return action.icon(prop);

    return action.icon;
  }

}
